import React from 'react';
import { Breadcrumb } from 'react-bootstrap';

const ClubRegistrationBreadcrumbComponent = ({ composingLabel, currentStep }) => {

    return (
        <Breadcrumb className='registrationBreadcrumbWrapper'>
            <Breadcrumb.Item className='registrationBreadcrumbItem' active={currentStep === 1}>
                <span className='registrationBreadcrumbItemContent'><h4 className='breaccrumbItemText'>{composingLabel('sportOauthLabel.clubRegister', 'Club register')}</h4></span>
            </Breadcrumb.Item>
            <Breadcrumb.Item className='registrationBreadcrumbItem' active={currentStep === 2}>
                <span className='registrationBreadcrumbItemContent'><h4 className='breaccrumbItemText'>{composingLabel('sportOauthLabel.systemAdministrator', 'System administrator')}</h4></span>
            </Breadcrumb.Item>
            <Breadcrumb.Item className='registrationBreadcrumbItem' active={currentStep === 3}>
                <span className='registrationBreadcrumbItemContent'><h4 className='breaccrumbItemText'>{composingLabel('sportOauthLabel.coachingPlayerPackage', 'CoachingPlayer package')}</h4></span>
            </Breadcrumb.Item>
            <Breadcrumb.Item className='registrationBreadcrumbItem' active={currentStep === 4}>
                <span className='registrationBreadcrumbItemContent'><h4 className='breaccrumbItemText'>{composingLabel('sportOauthLabel.sportSeasonDef', 'Sport season definition')}</h4></span>
            </Breadcrumb.Item>
        </Breadcrumb>
    )
}

export default ClubRegistrationBreadcrumbComponent;


// WEBPACK FOOTER //
// ./src/main/resources/js/components/RegistrationFormComponents/ClubRegistrationBreadcrumbComponent.js